import * as Yup from 'yup';

export default Yup.object().shape({
  email: Yup.string().email('signin.form.error.email_1').required('signin.form.error.email_2'),
  password: Yup.string().required('signin.form.error.email_1')
});
